import axios from "axios";

export const AUTH_API = axios.create({
  baseURL: `${process.env.REACT_APP_AUTH_API_URL}api/`,
  withCredentials: false,
});

export const createFormData = (data: any) => {
  const formData = new FormData();
  for (let key in data) {
    formData.append(key, data[key] || "");
  }
  return formData;
};

export const getLoginUrl = (domain: string) => {
  if (!domain) {
    domain = getDomainCookie();
  }
  const authUrl = process.env.REACT_APP_AUTH_API_URL.endsWith("/")
    ? process.env.REACT_APP_AUTH_API_URL
    : `${process.env.REACT_APP_AUTH_API_URL}/`;
  return `${authUrl}login?domain=${domain}`;
};

const getDomainCookie = () => {
  const match = document.cookie.match(/customer=([^;]+)/);
  return match ? match.pop() : "";
};
